import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledAccountOwnerContainer = styled.div<{ withPadding: boolean }>`
  padding: ${({ withPadding }) => (withPadding ? '8px 16px' : '0 0 16px')};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledAccountOwnerText = styled.div`
  ${setFontVariant('caption', colorsPalettes.carbon[400])};
`;

export const StyledAccountOwnerLink = styled.a`
  ${setFontVariant('tooltip', colorsPalettes.blue[300])};
  text-decoration: none;
  display: block;
`;
